const axios = require('axios');
const assert = require('assert');
const { errorMapper } = require('../ErrorMapper');

const CURRENT_VERSION = 'v1';

class FavouriteAddressConnector {

  constructor(configuration) {
    this.httpClient = axios.create(configuration);
  }

  async listBusinessAccountFavouriteAddress({ id, payload }) {
    assert(id, 'id is required');
    assert(payload, 'payload is required');

    try {
      const { data } = await this.httpClient.get(`/${CURRENT_VERSION}/favourite-address/business-account/${id}`, {
        params: payload,
      });
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async getFavouriteAddress({ id, payload }) {
    assert(id, 'id is required');
    assert(payload, 'payload is required');

    try {
      const { data } = await this.httpClient.get(`/${CURRENT_VERSION}/favourite-address/${id}`, {
        params: payload,
      });
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async createFavouriteAddress({ payload }) {
    assert(payload, 'payload is required');
    try {
      const { data } = await this.httpClient.post(`/${CURRENT_VERSION}/favourite-address`, payload);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async updateFavouriteAddress({ id, payload }) {
    assert(payload, 'payload is required');
    try {
      const { data } = await this.httpClient.patch(`/${CURRENT_VERSION}/favourite-address/${id}`, payload);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async deleteFavouriteAddress({ id }) {
    assert(id, 'id is required');
    try {
      const { data } = await this.httpClient.delete(`/${CURRENT_VERSION}/favourite-address/${id}`);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  _handleError(error) {
    throw errorMapper(error);
  }

}

module.exports = {
  FavouriteAddressConnector,
};
